module.exports = __webpack_public_path__ + "static/img/YB-T50.7e86b447.png";